{
  "title": "首页",
  "welcome": "欢迎来到首页，{{name}}，今年{{age}}岁，是一名{{job}}"
}
